var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-main',[_c('v-img',{staticClass:"my-3",attrs:{"src":"https://itsasmileworld.com/wp-content/uploads/2020/03/Its-a-smile-world-header-logo-300x300-1.png","contain":"","height":"200"}}),_c('AdminTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }